import { httpClient } from '@/lib/http-client'

export const engineQuestionsApi = {
    getAll: (params?: any) => httpClient.get('/questions', { params }),
    getById: (id: string) => httpClient.get(`/questions/${id}`),
    create: (data: any) => httpClient.post('/questions', data),
    update: (id: string, data: any) => httpClient.put(`/questions/${id}`, data),
    delete: (id: string) => httpClient.delete(`/questions/${id}`),
    importData: (form: FormData) =>
        httpClient.post('/questions/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/questions/export?format=${format}`,
}
